import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import {
	forwardRef,
	PropsWithChildren,
	ReactElement,
	Ref
} from "react";
import styles from "./ButtonGroup.module.less";

export type ButtonGroupProps = {
	doesContainSingleInput?: boolean;
	trackingId?: string;
};

export const ButtonGroup = forwardRef<HTMLDivElement, PropsWithChildren<ButtonGroupProps>>(
	(props: PropsWithChildren<ButtonGroupProps>, ref: Ref<HTMLDivElement>): ReactElement => {
		const {
			doesContainSingleInput = false,
			trackingId,
			children
		} = props;

		return (
			<div
				ref={ref}
				{...setTrackingId(trackingId)}
				className={
					classNames(
						styles.root,
						{[styles.root_forSingleInput]: doesContainSingleInput}
					)
				}
			>
				{children}
			</div>
		);
	}
);
ButtonGroup.displayName = "RichTextEditorToolbar.ButtonGroup";